import React from 'react'
// import { CalendarCheck2, ClipboardPenLine, Globe, Gpu, Handshake, Rocket } from 'lucide-react'
import { BsClipboard2, BsGlobe2, BsGpuCard, BsRocketTakeoff, BsCalendarCheck } from "react-icons/bs";
import { LuHandshake } from "react-icons/lu";

export default function WhyOwnCollegess() {

    return (
        <div className='px-[20px] sm:px-0 w-full sm:w-10/12 my-[30px] sm:my-[70px] relative mx-auto flex flex-col items-center'>
            <h4 className='text-[24px] sm:text-[36px] lg:text-[46px] text-[#2A2924] font-bold text-center'>Why to join Surge College?</h4>
            <div className='mt-[20px] sm:mt-[42px] sm:w-11/12 xl:w-10/12 mx-auto flex flex-wrap justify-center items-center gap-[20px] sm:gap-[64px]'>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#6bff3e] bg-[#6bff3e33] text-[#6bff3e] flex justify-center items-center'>
                        <BsGpuCard className='size-[25px]' />
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Digital Edge</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'>Dedicated Social Media App & Workfast.ai Access</p>

                </div>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#3eecff] bg-[#3eecff33] text-[#3eecff] flex justify-center items-center'>
                        <BsRocketTakeoff className='size-[25px]'/>
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Internships</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'>Guarenteed Internships (25/50/100)</p>

                </div>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#483eff] bg-[#483eff33] text-[#483eff] flex justify-center items-center'>
                        <BsClipboard2 className='size-[25px]'/>
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Training for Students</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'>Skill building that prepares students for today’s industry demands.</p>

                </div>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#ff3eef] bg-[#ff3eef33] text-[#ff3eef] flex justify-center items-center'>
                        <BsGlobe2 className='size-[25px]'/>
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Faculty Development Programs (FDPs)</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'> Empowering educators to stay industry-relevant</p>

                </div>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#fd3d3d] bg-[#fd3d3d33] text-[#fd3d3d] flex justify-center items-center'>
                        <LuHandshake className='size-[25px]'/>
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Startup Bootcamp</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'>Igniting the spirit of innovation and entrepreneurship.</p>

                </div>
                <div className='w-[280px] h-[220px] rounded-[10px] px-[24px] pt-[22px]' style={{boxShadow : "0px 1px 4px 0px #00000040"}}>
                    <div className='size-[50px] rounded-md border border-[#fd3d3d] bg-[#fd3d3d33] text-[#fd3d3d] flex justify-center items-center'>
                        <BsCalendarCheck className='size-[25px]'/>
                    </div>
                    <p className='text-[#252432] text-[20px] font-semibold mt-[12px]'>Events</p>
                    <p className='text-[#8987A1] text-[14px] font-normal mt-[12px]'>Conclaves & Conferences-High-impact events that bring the industry to your campus.</p>

                </div>
            </div>
            {/* <h5 className='text-[#000000] text-[16px] sm:text-[28px] lg:text-[32px] font-semibold text-center mt-[20px] sm:mt-[46px]'>The demand for AI driven business tools is rising. <br className='hidden lg:block'/> Position yourself for success!</h5> */}
            {/* <button className='py-[15px] px-[36px] rounded-full bg-[#FFDD09] text-[#2A2200] text-[13px] sm:text-[16px] font-semibold mt-[20px] sm:mt-[28px]' style={{boxShadow: "5px 5px 100px 0px #FFDD0933"}}>Check Pincode Availability & Apply Now</button> */}
        </div>
    )
}
